import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

/**
 * A small info affordance for a field whose *name* cannot carry its meaning.
 *
 * Some flags are only nameable in domain jargon — "Exempt from commission",
 * "External service" — where the label is accurate but tells an operator nothing
 * about when to tick it. The explanation belongs one hover away rather than as
 * body copy under every field: it is read once and then permanently in the way.
 *
 * Use it for a genuine explanation. A hint that merely restates its label is
 * clutter with an extra click, so leave those out entirely.
 */
export const FieldHint = ({ text, label }: { text: string; label?: string }) => (
  <Tooltip title={text}>
    <InfoCircleOutlined
      // Inside an antd Checkbox/Radio label, a click would toggle the control.
      // The tooltip opens on hover and focus, so swallowing the click costs
      // nothing and stops "I wanted to read it" from flipping a setting.
      onClick={(event) => event.preventDefault()}
      className="ml-1.5 cursor-help align-middle text-slate-400 hover:text-slate-600"
      aria-label={label ?? text}
    />
  </Tooltip>
);
